import styles from '../index.module.css'

import { RxCheck } from '@react-icons/all-files/rx/RxCheck'
import React from 'react'

import { HoverCard, Text } from 'components/ds'

import type { ColoredTag } from '../utils/indicator-colors'
import { TagDot } from './tag-dot'

type Props = {
  // Every colored tag, not only the hidden ones: the card is the full legend.
  tags: ColoredTag[]
  hiddenCount: number
  activeTagIds: ReadonlySet<number>
  onTagClick: (event: React.MouseEvent, tagId: number) => void
}

export const OverflowHoverCard = ({
  tags,
  hiddenCount,
  activeTagIds,
  onTagClick,
}: Props): React.ReactElement => (
  <HoverCard.Root>
    <HoverCard.Trigger>
      {/* A button rather than a Badge so keyboard users can open the card. */}
      <button
        type="button"
        className={styles.hoverableBadge}
        aria-label={`Show all ${tags.length} indicators`}
        data-testid="indicators-overflow-badge"
        // Opening the tag list must not select the track.
        onClick={event => event.stopPropagation()}
      >
        +{hiddenCount}
      </button>
    </HoverCard.Trigger>
    <HoverCard.Content
      size="1"
      side="top"
      align="start"
      className={styles.tagList}
      data-testid="indicators-hover-card"
    >
      {tags.map(tag => {
        const isActive = activeTagIds.has(tag.id)
        return (
          <button
            key={tag.id}
            className={styles.tagRow}
            type="button"
            aria-label={`Filter by ${tag.name}`}
            aria-pressed={isActive}
            data-testid="indicator-tag-row"
            onClick={event => onTagClick(event, tag.id)}
          >
            <TagDot tag={tag} />
            <Text weight="medium" as="span" className={styles.tagRowLabel}>
              {tag.name}
            </Text>
            {isActive && <RxCheck size={16} className={styles.tagRowCheck} />}
          </button>
        )
      })}
    </HoverCard.Content>
  </HoverCard.Root>
)
